/**
 * Image Search Agent - System Prompt Builder
 *
 * Assembles the 5-section system prompt for the Image Search agent.
 */
import { SystemPromptBuilder } from '../../../base/systemPrompt';
import { getIntroSection, IMAGE_SEARCH_INTRO } from './intro';
import { buildToolsSection } from './tools';
import { getSuggestionsSection, IMAGE_SEARCH_SUGGESTIONS } from './suggestions';
import { getContextNoteSection, IMAGE_SEARCH_CONTEXT_NOTE } from './contextNote';
import { getEvaluationSection, IMAGE_SEARCH_EVALUATION } from './evaluation';
/**
 * Build the complete system prompt for the Image Search agent.
 * Uses Keywords AI prompts if available, with code fallbacks.
 */
export function buildImageSearchSystemPrompt(params = {}) {
    const hasContext = params.resolvedContext && params.resolvedContext.length > 0;
    const builder = new SystemPromptBuilder();
    let prompt = builder.build({
        intro: getIntroSection(),
        tools: buildToolsSection(params.tools || []),
        suggestions: getSuggestionsSection(),
        contextNote: getContextNoteSection(hasContext),
        evaluation: getEvaluationSection(),
    });
    // Append resolved context if available
    if (hasContext && params.resolvedContext) {
        const contextDescriptions = params.resolvedContext.map(item => {
            const ids = Array.from(item.resolved.keys()).join(', ');
            return `- ${item.original.purpose} (IDs: ${ids})`;
        }).join('\n');
        prompt += `\n\n## Available Context\n${contextDescriptions}`;
    }
    return prompt;
}
// Export all sections for admin panel access
export { getIntroSection, buildToolsSection, getSuggestionsSection, getContextNoteSection, getEvaluationSection, IMAGE_SEARCH_INTRO, IMAGE_SEARCH_SUGGESTIONS, IMAGE_SEARCH_CONTEXT_NOTE, IMAGE_SEARCH_EVALUATION, };
// Variables and prompt configuration
export { IMAGE_SEARCH_VARIABLES, IMAGE_SEARCH_PROMPT_KEYS, IMAGE_SEARCH_PROMPT_CONFIG, } from './variables';
